<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15 15.998H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1Zm-2.5-4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" fill="currentColor"/><path d="M15.95 8.498H.193a3.659 3.659 0 0 1-.18-.867 3.623 3.623 0 0 1 .858-2.66 3.67 3.67 0 0 1 2.52-1.29A5.522 5.522 0 0 1 8.628 0a5.528 5.528 0 0 1 5.516 5.141 3.048 3.048 0 0 1 1.808 3.357Z" opacity=".45" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering191',
});
</script>
